import React, { useState } from "react";
import "./Contact.css";
import { motion } from "framer-motion";
import { FaEnvelope, FaMapMarkerAlt, FaLinkedin, FaGithub, FaPaperPlane } from "react-icons/fa";

const Contact = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState("");

  // 1. Single, clean change handler function
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // 2. Single, clean submit handler function sending proper FormData
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevents the browser page refresh redirect
    setStatus("sending");

    // Standard FormData body payload required by Getform endpoints
    const data = new FormData();
    data.append("name", formData.name);
    data.append("email", formData.email);
    data.append("message", formData.message);

    try {
      const response = await fetch("https://getform.io/f/7bce23c4-11a3-4244-a902-e0893ef410ef", {
        method: "POST",
        body: data,
        headers: {
          "Accept": "application/json" // Keeps response format readable
        }
      });

      if (response.ok) {
        setStatus("success");
        setFormData({ name: "", email: "", message: "" }); 
      setTimeout(() => {
        setStatus("");
      }, 5000);// Resets input forms back to empty string
      } else {
        setStatus("error");
      }
    } catch (error) {
      console.error("Submission error:", error);
      setStatus("error");
    }
  };

  return (
    <section className="contact-section" id="contact">
      <div className="contact-container">
        
        {/* Left Panel: Connect Info */}
        <motion.div 
          className="contact-info-panel"
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <span className="contact-subtitle">GET IN TOUCH</span>
          <h2 className="contact-title">Let's Connect</h2>
          <p className="contact-panel-desc">
            I'm open to discussing full-time engineering roles, backend integrations, or custom MERN stack architectures. Drop me a message!
          </p>

          <div className="info-details-list">
            <div className="info-item">
              <div className="info-icon-box"><FaEnvelope /></div>
              <div className="info-text">
                <span>Email Me</span>
                <p>chitrarasumit@gmail.com</p>
              </div>
            </div>
            <div className="info-item">
              <div className="info-icon-box"><FaMapMarkerAlt /></div>
              <div className="info-text">
                <span>Location</span>
                <p>Chennai, India</p>
              </div>
            </div>
          </div>

          <div className="contact-social-row">
            <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="social-circle-btn"><FaLinkedin /></a>
            <a href="https://github.com" target="_blank" rel="noreferrer" className="social-circle-btn"><FaGithub /></a>
          </div>
        </motion.div>

        {/* Right Panel: Interactive Form */}
        <motion.div 
          className="contact-form-panel"
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          <form onSubmit={handleSubmit} className="portfolio-contact-form">
            <div className="input-group-wrapper">
              <label htmlFor="name">Your Name</label>
              <input 
                type="text" 
                id="name"
                name="name" 
                value={formData.name} 
                onChange={handleChange} 
                required 
                placeholder="Enter your name"
              />
            </div>

            <div className="input-group-wrapper">
              <label htmlFor="email">Email Address</label>
              <input 
                type="email" 
                id="email"
                name="email" 
                value={formData.email} 
                onChange={handleChange} 
                required 
                placeholder="Enter your email"
              />
            </div>

            <div className="input-group-wrapper">
              <label htmlFor="message">Message</label>
              <textarea 
                id="message"
                name="message" 
                rows="5" 
                value={formData.message} 
                onChange={handleChange} 
                required 
                placeholder="Type your message here..."
              ></textarea>
            </div>

            <button 
              type="submit" 
              className={`form-submit-btn ${status === "sending" ? "btn-sending" : ""}`}
              disabled={status === "sending"}
            >
              {status === "sending" ? (
                "Sending..."
              ) : status === "success" ? (
                "Message Sent!"
              ) : status === "error" ? (
                "Failed to send. Try again!"
              ) : (
                <> Send Message <FaPaperPlane className="submit-btn-icon" /></>
              )}
            </button>
          </form>
        </motion.div>

      </div>
    </section>
  );
};

export default Contact;